import { ADDRESS_MODEL_KEY_LABEL, ADDRESS_MODEL_KEYS_SHIPPING, ADDRESS_MODEL_VALIDATOR } from 'models/daos/address/constants'
import isInLengthValidatorUtil from 'modules/redux/validators/is-in-length'
import { emailMessage } from 'messages'
import { isEmailValidatorUtil } from 'utils/validators/is-email'

const VALIDATOR = {
  firstName,
  lastName,
  email,
  postalCode,
  line1,
  city,
  state,
  phone
}

function getValidatorAddressUtil (name) {
  return VALIDATOR[name]
}

function firstName (value) {
  return isInLengthValidatorUtil({
    key: 'firstName',
    value,
    name: ADDRESS_MODEL_KEY_LABEL.firstName,
    min: ADDRESS_MODEL_VALIDATOR.firstName[0],
    max: ADDRESS_MODEL_VALIDATOR.firstName[1]
  })
}

function lastName (value) {
  return isInLengthValidatorUtil({
    key: 'lastName',
    value,
    name: ADDRESS_MODEL_KEY_LABEL.lastName,
    min: ADDRESS_MODEL_VALIDATOR.lastName[0],
    max: ADDRESS_MODEL_VALIDATOR.lastName[1]
  })
}

function email (value) {
  if (!isEmailValidatorUtil(value)) {
    return emailMessage()
  }
  return true
}

function postalCode (value) {
  return isInLengthValidatorUtil({
    key: 'postalCode',
    value,
    name: ADDRESS_MODEL_KEY_LABEL.postalCode,
    min: ADDRESS_MODEL_VALIDATOR.postalCode[0],
    max: ADDRESS_MODEL_VALIDATOR.postalCode[1]
  })
}

function line1 (value) {
  return isInLengthValidatorUtil({
    key: 'line1',
    value,
    name: ADDRESS_MODEL_KEY_LABEL.line1,
    min: ADDRESS_MODEL_VALIDATOR.line1[0],
    max: ADDRESS_MODEL_VALIDATOR.line1[1]
  })
}

function city (value) {
  return isInLengthValidatorUtil({
    key: 'city',
    value,
    name: ADDRESS_MODEL_KEY_LABEL.city,
    min: ADDRESS_MODEL_VALIDATOR.city[0],
    max: ADDRESS_MODEL_VALIDATOR.city[1]
  })
}

function state (value) {
  return isInLengthValidatorUtil({
    key: 'state',
    value,
    name: ADDRESS_MODEL_KEY_LABEL.state,
    min: ADDRESS_MODEL_VALIDATOR.state[0],
    max: ADDRESS_MODEL_VALIDATOR.state[1]
  })
}

function phone (value) {
  if (!value) {
    return true
  }
  return isInLengthValidatorUtil({
    key: 'phone',
    value,
    name: ADDRESS_MODEL_KEY_LABEL.phone,
    min: ADDRESS_MODEL_VALIDATOR.phone[0],
    max: ADDRESS_MODEL_VALIDATOR.phone[1]
  })
}

/**
 * Checks whether the key is required for shipping.
 * @param  {string}  key
 * @returns {boolean}
 */
function isKeyRequiredForShippingAddressUtil (key) {
  return ADDRESS_MODEL_KEYS_SHIPPING.includes(key)
}

export {
  getValidatorAddressUtil,
  isKeyRequiredForShippingAddressUtil
}
